export default [
  {
    path: "changeManager",
    name: "changeManager",
    component: (): Promise<any> => import(/* webpackChunkName: "admin:changeManager" */ "@/views/Admin/ChangeManagerView.vue")
  }
];